import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoint, colors, spacing } from '../../../themes';

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: ${spacing.small};
  position: relative;
`;

export const OuterTableContainer = styled.div`
  max-width: 100%;
  border: 1px solid ${colors.monochrome.grey20};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${colors.base.white};
`;

export const TableContainer = styled.div<{
  stickyHeader?: boolean;
}>`
  max-width: 100%;

  ${({ stickyHeader }) => {
    if (stickyHeader) {
      return css`
        max-height: 800px;
        overflow: auto;

        @media (max-width: ${breakpoint.medium}px) {
          max-height: 50vh;
        }
      `;
    }

    return css`
      overflow: hidden;
      overflow-x: auto;
    `;
  }};

  scrollbar-width: 8px;
  scrollbar-color: ${colors.monochrome.grey40} ${colors.base.white};

  @media (max-width: ${breakpoint.large}px) {
    overflow-x: scroll;
  }
`;

export const StyledTable = styled.table<{ responsiveBreakpoint?: keyof typeof breakpoint }>`
  border-collapse: collapse;
  width: 100%;
  background-color: ${colors.base.white};
  table-layout: fixed;

  @media (max-width: ${({ responsiveBreakpoint = 'large' }) =>
    breakpoint[responsiveBreakpoint]}px) {
    min-width: calc(
      4px + ${({ responsiveBreakpoint = 'large' }) => breakpoint[responsiveBreakpoint]}px - 2 *
        ${spacing.mediumHigh}
    );
  }
`;

export const TableBody = styled.tbody``;

export const EmptyTableWrapper = styled.div`
  width: 100%;
  border: 1px solid ${colors.monochrome.grey20};
`;
